import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useMount from '../../../../hooks/useMount';
import analytics from '../../../../modules/analytics';
import useJanitor from '../../../../hooks/useJanitor';
import FeatureFlags from '../../../../modules/FeatureFlags';
import SearchBoostEligibilityNotification from './SearchBoostEligibilityNotification';
import { getSelfPromotionDates } from '../../../../modules/Api';
import { hasPromotedProfileWithinLast3Days } from '../../today/SearchBoost/SearchBoostContainer';

import {
  PRO_SEARCH_BOOST_FLAG,
} from '../../constants';

export const SearchBoostEligibilityNotificationContainer = ({ notification }) => {
  const [showNotification, setShowNotification] = useState();
  const [showPromoteButton, setShowPromoteButton] = useState(true);

  const janitor = useJanitor();

  useMount(() => {
    janitor.addPromise(Promise.all([
      FeatureFlags.isEnabled(PRO_SEARCH_BOOST_FLAG),
      getSelfPromotionDates(notification.provider_id),
    ]))
      .then(([enabled, selfPromotedDates]) => {
        setShowNotification(enabled);
        const { last_self_promoted_date: lastSelfPromotedDate } = selfPromotedDates;
        const promotedWithinLast3Days = hasPromotedProfileWithinLast3Days(lastSelfPromotedDate);
        setShowPromoteButton(!promotedWithinLast3Days);
      });
  });

  if (showNotification) {
    analytics.track(`pro_notification_search_boost_eligibility_${showPromoteButton ? 'promote_profile' : 'add_appointment'}_viewed`);

    return (
      <SearchBoostEligibilityNotification
        notification={notification}
        showPromoteButton={showPromoteButton}
      />
    );
  }

  return null;
};

SearchBoostEligibilityNotificationContainer.propTypes = {
  notification: PropTypes.object.isRequired,
};

export default SearchBoostEligibilityNotificationContainer;
